// extracted by mini-css-extract-plugin
export default {"OpenAIChatGptContainer":"OpenAIChatGpt_OpenAIChatGptContainer__2wOhi","title":"OpenAIChatGpt_title__s2yx8","label":"OpenAIChatGpt_label__bcWsu"};